import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatchEvent } from '../../../models';

@Component({
  selector: 'timeline-event',
  templateUrl: './timeline-event.component.html',
  styleUrls: ['./timeline-event.component.css']
})
export class TimelineEventComponent {
  @Input() matchEvent: MatchEvent;
  @Input() eventIndex: number;
  @Input() left: string;

  @Output() readonly selected = new EventEmitter<MatchEvent>();
  constructor() {}

  /* Occurs when user click on a CodeEvent */
  onSelect(matchEvent: MatchEvent) {
    console.info('[TimelineEventComponent] selected:', matchEvent);
    this.selected.emit(matchEvent);

    (<any>window).gtag('event', 'event-selected', {
      'event_category' : 'timeline',
      'event_label' : matchEvent.eventType
    });
  }
}
